import React, { Fragment } from "react";
import {
  Toolbar,
  SaveButton,
  BooleanInput,
  required,
  SelectInput,
  Create,
  SimpleForm,
  TextInput
} from "react-admin";
import { useLocation } from "react-router";
import PersonReferenceInput from "./PersonReferenceInput";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    fontSize: "20px"
  },
  button: {
    marginRight: "10px"
  }
});

const PlayerCreateToolbar = (props) => {
  const styles = useStyles();
  return (
    <Toolbar {...props}>
      <SaveButton label="Save" className={styles.button} redirect="edit" />
      <SaveButton
        label="Save and add another"
        className={styles.button}
        redirect={{ path: "create", state: useLocation().state }}
      />
    </Toolbar>
  );
};

const PlayerCreate = (props) => {
  const classes = useStyles();
  const redirect = function(basePath, id, data) {
    return `/seasonTeams/${data.team.id}/show/7`;
  };
  const players = _.get(props, "location.state.players", []);
  const { state } = useLocation();
  const teamInfo = _.get(state, "teamInfo");

  return (
    <Fragment>
      <h1 className={classes.title}>{`Add Player to ${teamInfo}`}</h1>
      <Create {...props}>
        <SimpleForm redirect={redirect} toolbar={<PlayerCreateToolbar />}>
          <PersonReferenceInput
            source="person.id"
            allowEmpty
            validate={required()}
            players={players || []}
          />
          <TextInput source="jerseyNumber" />
          <TextInput source="position" />
          <TextInput source="additionalPositions" />
          <SelectInput
            source="yearCode"
            allowEmpty="true"
            choices={[
              { id: "FRESHMAN", name: "FRESHMAN" },
              { id: "SOPHOMORE", name: "SOPHOMORE" },
              { id: "JUNIOR", name: "JUNIOR" },
              { id: "SENIOR", name: "SENIOR" }
            ]}
          />
          <BooleanInput source="isActive" validate={required()} />
        </SimpleForm>
      </Create>
    </Fragment>
  );
};

export default PlayerCreate;
